import { Button, Card, Form, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import React, { useState } from 'react';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { buildInterestKeyFromLabel } from './interestKey';

const AdminCreateTagComponent = ({ setLoading, onCreate }) => {
  const { database, currentUser, storage } = useFirebase();
  const [newTag, setNewTag] = useState<{ label: string; interestKey: string; showAsSeries: boolean; order: number; visibleFor: { odontoiatra: boolean; aso: boolean } }>({
    label: '',
    interestKey: '',
    showAsSeries: false,
    order: 0,
    visibleFor: {
      odontoiatra: false,
      aso: false,
    },
  });
  const [tagImage, setTagImage] = useState<File>(null);
  const generatedInterestKey = buildInterestKeyFromLabel(newTag.label);

  return (
    <Card bg={'dark'} style={{ gridArea: 'span 1 / span 2' }}>
      <Card.Header>
        <Card.Title className={'mb-0'}>
          <InputGroup>
            <Form.Control
              placeholder={'Crea nuovo tag...'}
              value={newTag.label}
              onChange={(e) => setNewTag((current) => ({ ...current, label: e.target.value.trim() }))}
            />
            <InputGroup.Append>
              <Button
                variant={'primary'}
                disabled={!newTag.label || !generatedInterestKey}
                onClick={async () => {
                  try {
                    const interestKey = newTag.interestKey || generatedInterestKey;
                    if (!interestKey) return;
                    const tagToCreate = { ...newTag, interestKey };

                     // Create the tag in database
                    const docRef = await database.collection('tags').add({
                      ...tagToCreate,
                      i18n: { it: { label: newTag.label } },
                      lastEditBy: currentUser.uid 
                    });
                    
                    // Handle image upload if present
                    if (tagImage) {
                      const storageRef = storage.child(`tags_data/${docRef.id}/image.webp`);
                      await storageRef.put(tagImage, { customMetadata: { uid: currentUser.uid } });
                    }
                    
                     // Create the new tag object to pass back to parent
                      const createdTag = {
                        id: docRef.id,
                        ...tagToCreate,
                        i18n: { it: { label: newTag.label } },
                        lastEditBy: currentUser.uid,
                        image: tagImage ? `tags_data/${docRef.id}/image.webp` : null
                     };
                    
                    // Reset form
                    setNewTag({
                      label: '',
                      interestKey: '',
                      showAsSeries: false,
                      order: 0,
                      visibleFor: {
                        odontoiatra: false,
                        aso: false,
                      },
                    });
                    setTagImage(null);
                    
                    // Pass the created tag back to parent
                    onCreate(createdTag);
                  } catch (error) {
                    console.error(error);
                  }
                }}
              >
                <FontAwesomeIcon icon={faSave} />
              </Button>
            </InputGroup.Append>
          </InputGroup>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <div>
          <Form.Check
            type={'checkbox'}
            id={'chkSerie'}
            inline
            label={'Mostra come serie (categoria)?'}
            checked={newTag.showAsSeries}
            onChange={(e) => setNewTag((current) => ({ ...current, showAsSeries: e.target.checked }))}
          />

          <Form.Check
            type={'checkbox'}
            id={'chkOdontoiatra'}
            inline
            label={'Visibile per Odontoiatra?'}
            checked={newTag.visibleFor.odontoiatra}
            onChange={(e) => setNewTag((current) => ({ ...current, visibleFor: { ...current.visibleFor, odontoiatra: e.target.checked } }))}
          />

          <Form.Check
            type={'checkbox'}
            id={'chkAso'}
            inline
            label={'Visibile per ASO?'}
            checked={newTag.visibleFor.aso}
            onChange={(e) => setNewTag((current) => ({ ...current, visibleFor: { ...current.visibleFor, aso: e.target.checked } }))}
          />
        </div>
        <div className={'d-flex align-items-baseline'}>
          <strong>Ordine:</strong>
          <Form.Control
            className={'ml-2'}
            style={{ maxWidth: '110px' }}
            type={'number'}
            value={newTag.order}
            size={'sm'}
            onChange={(e) => setNewTag((current) => ({ ...current, order: +e.target.value }))}
          />
          <Form.File className={'ml-3'} accept={'image/webp'} onChange={(e) => setTagImage(e.target.files[0])} />
        </div>
      </Card.Body>
    </Card>
  );
};

export { AdminCreateTagComponent as AdminCreateTag };
